import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import { MallFragment } from "@saleor/fragments/types/MallFragment";
import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import { FilterPageProps, PageListProps, TabPageProps } from "@saleor/types";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import { canManageMalls } from "@saleor/utils/handlers/userHandler";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import MallList from "../MallList";
import {
  createFilterStructure,
  MallFilterKeys,
  MallListUrlFiltersOpts
} from "./filters";

export interface MallTableProps
  extends PageListProps,
    TabPageProps,
    FilterPageProps<MallFilterKeys, MallListUrlFiltersOpts> {
  malls: MallFragment[];
}

export const MallListPage: React.FC<MallTableProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  currencySymbol,
  onAdd,
  ...listProps
}) => {
  const intl = useIntl();
  const use_ = useUser();
  const structure = createFilterStructure(intl, filterOpts);
  const breadcrumbDirectory = [
    {
      name: "Malls"
    }
  ];
  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      {use_ &&
        use_.user &&
        use_.user.userType &&
        use_.user.userType.code !== SmopUserTypeCode.MARKETING && (
          <PageHeader title={intl.formatMessage(sectionNames.malls)}>
            <Button
              color="primary"
              variant="contained"
              onClick={onAdd}
              id="createMallBtn"
              disabled={!canManageMalls()}
            >
              <FormattedMessage
                defaultMessage="Create mall"
                description="button"
              />
            </Button>
          </PageHeader>
        )}
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          tabs={tabs}
          filterStructure={structure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Mall"
          })}
          initialSearch={initialSearch}
          onSearchChange={onSearchChange}
          onFilterChange={onFilterChange}
          onAll={onAll}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <MallList {...listProps} />
      </Card>
    </Container>
  );
};
MallListPage.displayName = "MallListPage";
export default MallListPage;
